module.exports = __webpack_public_path__ + "static/media/booth.a6b32194.png";